const strings = Object.freeze({
  patient: Object.freeze({
    moodTitle: 'Mood',
    moodLegendTitle: 'Intensity',
    phq9Title: 'PHQ-9 Score',
    phq9Desc: 'The Patient Health Questionnaire - 9 item version (PHQ-9) is a concise, patient-rated tool to measure the severity of each of the 9 DSM-IV criteria for Major Depressive Disorder.  PHQ-9 scores range from 0 to 27 with higher scores indicating greater MDD symptom severity.',
    phq9Link: 'http://www.phqscreeners.com/',
    medsTitle: 'Medications & Side Effects',
    mmas4Title: 'Medication Adherence',
    mmas4Desc: 'MMAS-4 : The Morisky Medication-taking Adherence Scale - 4 item version (MMAS-4) is a concise, patient-rated tool to assess medication-taking behavior.  MMAS-4 scores range from 0-4 with higher scores indicating medication non-adherence.',
    sleepTitle: 'Sleep',
    activityTitle: 'Activity',
    appetiteTitle: 'Appetite'
  }),
  addPatient: Object.freeze({
    nameLabel: 'Name',
    emailLabel: 'Email',
    smsLabel: 'SMS',
    firstNamePlaceholder: 'First Name',
    lastNamePlaceholder: 'Last Name',
    phoneNumberPlaceholder: 'Phone Number',
    emailPlaceholder: 'Email Address'
  }),
  auth: Object.freeze({
    signupLabel: 'Create an account',
    signupBtn: 'Sign up',
    signupLink: 'Create account',
    loginLabel: 'Log in',
    loginBtn: 'Log in',
    loginLink: 'Log in',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    accessCodePlaceholder: 'Access code'
  }),
  patientList: Object.freeze({
    patientsTab: 'My Patients',
    activeStatus: 'Active',
    notEnrolledStatus: 'Not yet enrolled',
    headerNameCol: 'Name',
    headerStatusCol: 'Status',
    headerDayCol: 'Day',
    logoutBtn: 'Logout'
  })
});

export default strings;



// WEBPACK FOOTER //
// ./src/lib/strings.js